import React from 'react'
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom'

import { useUser } from 'context/user-context'
import Dashboard from 'components/Dashboard'
import WhatsappButton from 'components/WhatsappButton'

import Login from './Login'
import SignUp from './partners/SignUp'
import ForgotPassword from './partners/ForgotPassword'
import NewPassword from './partners/NewPassword'

import OrderHistory from './partners/order-history'
import ShowOrder from './partners/packages/Order'

import NewBeneficiary from './partners/beneficiaries/New'
import BeneficiariesList from './partners/beneficiaries/List'
import BeneficiaryShow from './partners/beneficiaries/Show'
import EditBeneficiary from './partners/beneficiaries/Edit'

import GroupsIndex from './partners/groups'
import AttributeBeneficiary from './partners/BeneficiariesGroup/Attribution/New'
import AttributeGroup from './partners/BeneficiariesGroup/Attribution/Show'
import NewGroup from './partners/BeneficiariesGroup/New'
import EditGroup from './partners/BeneficiariesGroup/Edit'

import GiftCardsList from './partners/GiftCards'
import GiftCardOrder from './partners/GiftCards/Order'
import GiftCardsTypeList from './partners/GiftCards/CardsList'
import Settings from './partners/Settings/Configurations'
import ResetPassword from './partners/Settings/ResetPassword'
import EditInfo from './partners/Settings/Edit'
import Catalog from './partners/catalog'
import MyPackages from './partners/my-packages'

import CouponsList from './staff/coupons/List'
import CouponsEdit from './staff/coupons/Edit'
import NewCoupon from './staff/coupons/New'
import CouponDetail from './staff/coupons/Show'

import PreRegistrationList from './staff/partners/PreRegistrationList'
import PartnersList from './staff/partners/List'
import PartnersShow from './staff/partners/Show'
import PartnersEdit from './staff/partners/Edit'
import PartnersPriceEdit from './staff/partners/Show/PriceEdit'
import PartnersPurchaseList from './staff/partners/PurchaseHistory'
import PartnersPurchaseDetail from './staff/partners/PurchaseDetail'
import PartnersOrdersNew from './staff/partners/orders/New'
import PartnersGiftCard from './staff/partners/GiftCard'
import PartnersGiftCardOrder from './staff/partners/GiftCard/Order'
import PartnersGiftCardsList from './staff/partners/GiftCard/List'
import PartnersGiftCardNewOrder from './staff/partners/GiftCard/New'
import PartnersGiftCardNewCardType from './staff/partners/GiftCard/NewCardType'

import PackagesList from './staff/packages/List'
import PackagesEdit from './staff/packages/Edit'

import StaffBeneficiariesList from './staff/beneficiaries/List'

import StaffSettings from './staff/settings'
import SettingsEditPassword from './staff/settings/edit-password'

const PrivateRoutes = () => {
  const { user } = useUser()

  if (user.company_name) {
    return (
      <Router>
        <Dashboard>
          <Switch>
            <Route exact path='/prepaid-purchase/my-packages/list' component={MyPackages} />
            <Route path='/prepaid-purchase/my-packages/order-history/:id' component={ShowOrder} />
            <Route path='/prepaid-purchase/my-packages/order-history' component={OrderHistory} />

            <Route exact path='/prepaid-purchase/beneficiaries' component={BeneficiariesList} />
            <Route exact path='/prepaid-purchase/beneficiaries/new' component={NewBeneficiary} />
            <Route exact path='/prepaid-purchase/beneficiaries/edit/:name/:id' component={EditBeneficiary} />
            <Route path='/prepaid-purchase/beneficiaries/:id' component={BeneficiaryShow} />

            <Route exact path='/prepaid-purchase/groups' component={GroupsIndex} />
            <Route path='/prepaid-purchase/groups/new' component={NewGroup} />
            <Route exact path='/prepaid-purchase/groups/attribution/new/:name/:id' component={AttributeBeneficiary} />
            <Route path='/prepaid-purchase/groups/attribution/:id' component={AttributeGroup} />
            <Route path='/prepaid-purchase/groups/edit/:id' component={EditGroup} />

            <Route path='/prepaid-purchase/gift-cards' exact component={GiftCardsList} />
            <Route path='/prepaid-purchase/gift-cards/order/:id' exact component={GiftCardOrder} />
            <Route path='/prepaid-purchase/gift-cards/order/:id/cards' component={GiftCardsTypeList} />

            <Route exact path='/settings' component={Settings} />
            <Route path='/settings/password' component={ResetPassword} />
            <Route path='/settings/edit' component={EditInfo} />

            <Route path='/prepaid-purchase/catalog' component={Catalog} />
            <Redirect to='/prepaid-purchase/my-packages/list' />
          </Switch>
        </Dashboard>
      </Router>
    )
  } else {
    return (
      <Router>
        <Dashboard>
          <Switch>
            <Route path='/staff/promotions/coupons' exact component={CouponsList} />
            <Route path='/staff/promotions/coupons/new' component={NewCoupon} />
            <Route path='/staff/promotions/coupons/:id' exact component={CouponDetail} />
            <Route path='/staff/promotions/coupons/:id/edit' component={CouponsEdit} />

            <Route path='/staff/partners/list/orders/new' component={PartnersOrdersNew} />
            <Route path='/staff/partners/pre-registrations' component={PreRegistrationList} />
            <Route path='/staff/partners/list' exact component={PartnersList} />
            <Route path='/staff/partners/list/:id/edit' exact component={PartnersEdit} />
            <Route path='/staff/partners/list/:id/prices/:package_id/edit' exact component={PartnersPriceEdit} />
            <Route path='/staff/partners/list/:partnerID/beneficiaries' exact component={StaffBeneficiariesList} />
            <Route path='/staff/partners/list/:id' exact component={PartnersShow} />

            <Route path='/staff/prepaid-partners/purchase-history' exact component={PartnersPurchaseList} />
            <Route
              path='/staff/prepaid-partners/purchase-history/orders/:id'
              exact
              component={PartnersPurchaseDetail}
            />
            <Route path='/staff/prepaid-partners/gift-card' exact component={PartnersGiftCard} />
            <Route path='/staff/prepaid-partners/gift-card/order/:id' exact component={PartnersGiftCardOrder} />
            <Route path='/staff/prepaid-partners/gift-card/list' exact component={PartnersGiftCardsList} />
            <Route path='/staff/prepaid-partners/gift-card/new-order' exact component={PartnersGiftCardNewOrder} />
            <Route path='/staff/prepaid-partners/gift-card/new-card-type' component={PartnersGiftCardNewCardType} />
            <Route path='/staff/prepaid-partners/beneficiaries' exact component={StaffBeneficiariesList} />
            <Route path='/staff/prepaid-partners/packages' exact component={PackagesList} />
            <Route path='/staff/prepaid-partners/packages/:id' exact component={PackagesEdit} />

            <Route path='/staff/settings' exact component={StaffSettings} />
            <Route path='/staff/settings/edit-password' exact component={SettingsEditPassword} />

            <Redirect to='/staff/promotions/coupons' />
          </Switch>
        </Dashboard>
      </Router>
    )
  }
}

const PublicRoutes = () => {
  return (
    <Router>
      <Switch>
        <Route exact path={['/', '/login']} component={Login} />
        <Route path='/sign-up' component={SignUp} />
        <Route path='/forgot-password' component={ForgotPassword} />
        <Route path='/redefine-password' component={NewPassword} />
        <Redirect to='/login' />
      </Switch>
    </Router>
  )
}

const PrepaidRoutes = () => {
  const { user } = useUser()
  return (
    <>
      {user ? <PrivateRoutes /> : <PublicRoutes />}
      <WhatsappButton />
    </>
  )
}

export default PrepaidRoutes
